import { AppDispatch } from "../../../slices/store";
import {scrollToTop} from "../../../utils/helpers/helperMethods/scrollToTop";
import { deleteClient } from "../../../slices/clients/clientManagementSlice";
import {editUser} from "../../../slices/users/userManagementSlice";

export  const handleDeleteClientService = (
    data:any,
    reqRequests:any,
    setIsLoading:any,
    dispatch: AppDispatch,
    addAlert: Function,
    shouldRedirect:boolean,
    navigate: Function,
    getClients: any,
    protectedResources: any
) => {

    const params = {
        id: data.id,
        accessToken: localStorage.getItem('AccessToken') || "llll",
        url: protectedResources.apiTodoList.endpoint + '/users/'+ data.id,
    }
    dispatch(deleteClient(params)).then((r:any) => {
        setIsLoading(true);
        scrollToTop();
        if (r?.payload?.success === true){
            addAlert("Customer Deleted Successfully", "success", true);
            dispatch(getClients(reqRequests)).then((r :any)=>{
                if (r.payload.succeeded) {
                    setIsLoading(false);
                    if (shouldRedirect){
                        navigate(-1);
                    }
                }
            })
        }
    }).catch(e => {
        addAlert("Customer Deleted Failed", "failed", true);
    })
}

export const handleEditCustomer = (
  data:any,
  dispatch: AppDispatch,
  setIsLoading:any,
  addAlert: Function,
  shouldRedirect:boolean,
  navigate: Function,
  protectedResources: any,
  url: string,
  reqRequests: any,
  getClients: any,
) =>{
  const params = {
    user: data,
    accessToken: localStorage.getItem('AccessToken') || "",
    url: url,
    imageURL: "",
    selectedFile: null,

  }

  dispatch(editUser(params)).then((r:any) => {
    scrollToTop();
    if (r?.payload?.status  === "success"){
      addAlert("User Edited Successfully", "success", true);
      dispatch(getClients(reqRequests)).then((r :any)=>{
        if (r.payload.succeeded) {
          setIsLoading(false);
          if (shouldRedirect){
            navigate(-1);
          }
        }
      })
    }
  }).catch(e => {
    setIsLoading(false);
    addAlert("Customer Edit Failed", "failed", true);
  })
}
